<template>
<div class="chapter">
<div class="inner_page">
<div class="chapterHead" id="Table_of_Contents">
<h2 class="chapterTitle3">Contents</h2>
</div>
<p class="contentsEntry2"><a href="#/03_Preface">Preface</a></p>
<p class="contentsEntry2"><a href="#/04_Photograph_Sources">Photograph Source</a></p>
<p class="contentsEntry2"><a href="#/05_Introduction">Introduction: The Road to Barbarossa</a></p>
<p class="contentsEntry1"><a href="#/06_00_Chapter_One">Chapter One</a></p>
<p class="contentsEntry"><a href="#/06_00_Chapter_One">Stalin’s Armoured Fist</a></p>
<p class="contentsEntry1"><span href="#/07_00_Chapter_Two" title="Link target outside of Sample">Chapter Two</span></p>
<p class="contentsEntry"><span href="#/07_00_Chapter_Two" title="Link target outside of Sample">Hitler’s Axis Armour</span></p>
<p class="contentsEntry1"><span href="#/08_00_Chapter_Three" title="Link target outside of Sample">Chapter Three</span></p>
<p class="contentsEntry"><span href="#/08_00_Chapter_Three" title="Link target outside of Sample">Barbarossa – The Red Army Smashed</span></p>
<p class="contentsEntry1"><span href="#/09_00_Chapter_Four" title="Link target outside of Sample">Chapter Four</span></p>
<p class="contentsEntry"><span href="#/09_00_Chapter_Four" title="Link target outside of Sample">Zhukov’s Moscow Miracle</span></p>
<p class="contentsEntry1"><span href="#/10_00_Chapter_Five" title="Link target outside of Sample">Chapter Five</span></p>
<p class="contentsEntry"><span href="#/10_00_Chapter_Five" title="Link target outside of Sample">Timoshenko’s Kharkov Riposte</span></p>
<p class="contentsEntry1"><span href="#/11_00_Chapter_Six" title="Link target outside of Sample">Chapter Six</span></p>
<p class="contentsEntry"><span href="#/11_00_Chapter_Six" title="Link target outside of Sample">Disaster at Stalingrad</span></p>
<p class="contentsEntry1"><span href="#/12_00_Chapter_Seven" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="contentsEntry"><span href="#/12_00_Chapter_Seven" title="Link target outside of Sample">Manstein’s Kharkov Comeback</span></p>
<p class="contentsEntry1"><span href="#/13_00_Chapter_Eight" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="contentsEntry"><span href="#/13_00_Chapter_Eight" title="Link target outside of Sample">Clash of the Titans – Kursk</span></p>
<p class="contentsEntry1"><span href="#/14_00_Chapter_Nine" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="contentsEntry"><span href="#/14_00_Chapter_Nine" title="Link target outside of Sample">Stalin’s Steamroller – Bagration</span></p>
<p class="contentsEntry1"><span href="#/15_00_Chapter_Ten" title="Link target outside of Sample">Chapter Ten</span></p>
<p class="contentsEntry"><span href="#/15_00_Chapter_Ten" title="Link target outside of Sample">T-34s on the Oder</span></p>
<p class="contentsEntry1"><span href="#/16_00_Chapter_Eleven" title="Link target outside of Sample">Chapter Eleven</span></p>
<p class="contentsEntry"><span href="#/16_00_Chapter_Eleven" title="Link target outside of Sample">Seelow and the Last Tank Battle</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Table_of_Contents.vue?731f171f